module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/img/trust-and-transparency-mobile.b1e8d57b.jpg";